import { render, staticRenderFns } from "./DebtorForm.vue?vue&type=template&id=4f278a0f&"
import script from "./DebtorForm.vue?vue&type=script&lang=js&"
export * from "./DebtorForm.vue?vue&type=script&lang=js&"
import style0 from "./DebtorForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports